import React, { useEffect, useCallback, useState} from 'react';
import WaveformSelector from './WaveformSelector.js';
import {connect} from 'react-redux';

const OscillatorWaveform = ({oscillatorType, oscillator}) => { 
    let [showing, setShowing] = useState(false);
    let className = "oscillator-waveform";
    if (showing) {
        className += " showing";
    }
    return (
        <div
          onMouseDown={() => setShowing(!showing)} className={className}>
          <div className="waveform-type">{oscillatorType}</div>
          {showing ? <WaveformSelector hide={() => setShowing(false)} oscillator={oscillator}/> : ''}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      oscillatorType: 
          props.oscillator.customOscillatorType ||
          props.oscillator.oscillatorType
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OscillatorWaveform);
